import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {
  Box,
  P,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";

const FeatursCard = styled(Grid)`
  align-items: center;
  text-align: center;
  @media screen and (max-width: 899px) {
    min-height: 345px
  }
`;

const LiquidImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 150px;
`
const WalletImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 210px;
`

const index = () => {
  return (
    <div id="features">
      <SectionWrapper pt650px="20px">
        <Container maxWidth="xl">
          <SectionSubHeading tc="center">Features</SectionSubHeading>
          <Grid container spacing={2} sx={{justifyContent: "center"}}>
            <Grid item sx={12} sm={6}>
              <Box
                display="flex"
                pl899px="40px"
                maxWidth="90%"
                minheight="215px"
                pl="0px"
                padding599="20px"
              >
                <FeatursCard container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <LiquidImage
                      src="/images/Liquidity.png"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SectionSubHeading
                      align="center"
                      mt="0px"
                      mb="0px"
                      fs="30px"
                      tc="left"
                    >
                      Auto Liquidity
                    </SectionSubHeading>
                    <P align700="center">3% into Liquidity pool</P>
                  </Grid>
                </FeatursCard>
              </Box>
            </Grid>
            <Grid item sx={12} sm={6}>
              <Box
                display="flex"
                padding599="20px"
                pl899px="40px"
                minheight="215px"
                pl="0px"
                maxWidth="90%"
              >
                <FeatursCard container>
                  <Grid xs={12} md={6}>
                    <WalletImage
                      src="/images/wallet.png"
                    />
                  </Grid>
                  <Grid xs={12} md={6}>
                    <SectionSubHeading
                      align="center"
                      mt="0px"
                      mb="0px"
                      fs="30px"
                      tc="left"
                    >
                      Tax Wallet
                    </SectionSubHeading>
                    <P align700="center">3% Marketing/Dev/BuyBack</P>
                  </Grid>
                </FeatursCard>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
